import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL, PIXEL_CONTENT_NAME, pricing } from '../data/poolContent';
import { trackPixelEvent } from '../utils/metaPixel';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-312" data-mp="3ubu2ppl0kx39">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-0 left-0 right-0 z-50 box-border w-full max-w-[100vw] border-t border-aqua/25 bg-abyss-950/95 px-3 pb-[max(0.625rem,env(safe-area-inset-bottom))] pt-2.5 backdrop-blur lg:hidden" data-id="element-313" data-mp="3glgs1fgqn4a8">
          <div className="mx-auto box-border flex w-full max-w-md items-center justify-between gap-3" data-id="element-314" data-mp="76nnonztkn01">
            <p className="shrink-0 font-display text-[1.6rem] font-bold leading-none text-frost-50 min-[360px]:text-[1.8rem]" data-id="element-315" data-mp="283xgbe70p1v">
              {pricing.today}
            </p>
            <a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: PIXEL_CONTENT_NAME,
          value: pricing.todayValue,
          currency: 'USD'
        })} className="box-border flex min-w-0 flex-1 items-center justify-center whitespace-nowrap rounded-full bg-aqua px-3 py-3.5 text-center text-[11px] font-bold uppercase leading-none tracking-[0.06em] text-abyss-950 transition-colors duration-150 ease-out active:bg-aqua-light min-[360px]:text-[12px] min-[360px]:tracking-[0.1em]" data-id="element-316" data-mp="c4p5l5lieg9x">
              Get Instant Access
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}